export default __webpack_public_path__ + "static/media/797.54db8025.png";